<div class="add-container">
  <app-sidenav-header [title]="title"></app-sidenav-header>
  <div class="p-24" class="form-section pr-10">
    <form [formGroup]="createSolutionForm" class="p-8">
      <div class="flex flex-col mb-16">
        <div class="flex flex-row justify-start items-center">
          <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.SOLUTION_NAME' | transloco | uppercase }}</label>
          <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.SOLUTION_NAME' | transloco"
            matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
        </div>
        <input formControlName="name" placeholder="{{'ADD_SOLUTION.SOLUTION_NAME' | transloco}}" class="fw-500" required>
        <app-error [control]="createSolutionForm.get('name')"></app-error>
      </div>

      <div class="flex flex-row gap-8">
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.SHORT_DESCRIPTION' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.PLACE_HOLDER.DESCRIPTION' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <textarea formControlName="shortDescription" placeholder="{{'ADD_SOLUTION.PLACE_HOLDER.DESCRIPTION' | transloco}}" class="fw-500 text-area" required></textarea>
          <app-error [control]="createSolutionForm.get('shortDescription')"></app-error>
        </div>
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.LONG_DESCRIPTION' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.PLACE_HOLDER.DESCRIPTION' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <textarea formControlName="longDescription" placeholder="{{'ADD_SOLUTION.PLACE_HOLDER.DESCRIPTION' | transloco}}" class="fw-500 text-area" required></textarea>
          <app-error [control]="createSolutionForm.get('longDescription')"></app-error>
        </div>
      </div>
      
      <div class="flex flex-row gap-8">
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.TAG_LINE' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.TAG_LINE' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <input formControlName="tagline" placeholder="{{'ADD_SOLUTION.TAG_LINE' | transloco}}" class="fw-500" required>
          <app-error [control]="createSolutionForm.get('tagline')"></app-error>
        </div>
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.PUNCH_LINE' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.PUNCH_LINE' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <input formControlName="punchline" placeholder="{{'ADD_SOLUTION.PUNCH_LINE' | transloco}}" class="fw-500" required>
          <app-error [control]="createSolutionForm.get('punchline')"></app-error>
        </div>
      </div>

      <div class="flex flex-row gap-8">
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.LINE_OF_BUSINESS' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.PLACE_HOLDER.CHOOSE_LINE_OF_BUSINESS' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <mat-select multiple [formControl]="createSolutionForm.get('lineOfBusiness')" class="fw-500 form-select" [placeholder]="'ADD_SOLUTION.PLACE_HOLDER.CHOOSE_LINE_OF_BUSINESS' | transloco" required>
            <mat-option *ngFor="let option of lineOfBusinessOptions" [value]="option.value">{{ option.value | titlecase }}</mat-option>
          </mat-select>

          <app-error [control]="createSolutionForm.get('lineOfBusiness')"></app-error>
        </div>
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.REGION_AVAILABILITY' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.PLACE_HOLDER.CHOOSE_REGION' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <mat-select multiple [formControl]="createSolutionForm.get('regionalAvailability')" class="fw-500 form-select" [placeholder]="'ADD_SOLUTION.PLACE_HOLDER.CHOOSE_REGION' | transloco" required>
            <mat-option *ngFor="let option of regionOptions" [value]="option.value">{{ option.value }}</mat-option>
          </mat-select>
          <app-error [control]="createSolutionForm.get('regionalAvailability')"></app-error>
        </div>
      </div>

      <div class="flex flex-row gap-8">
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.CATEGORY' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.PLACE_HOLDER.CHOOSE_CATEGORY' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <select [formControl]="createSolutionForm.get('category')" class="fw-500 form-select" required>
            <option [ngValue]="null" [disabled]="true" hidden>{{'ADD_SOLUTION.PLACE_HOLDER.CHOOSE_CATEGORY' | transloco}}</option>
            <option *ngFor="let option of categoryOptions" [ngValue]="option.value">{{ option.value }}</option>
          </select>
          <app-error [control]="createSolutionForm.get('category')"></app-error>
        </div>
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.STATUS' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.PLACE_HOLDER.CHOOSE_STATUS' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <select [formControl]="createSolutionForm.get('status')" class="fw-500 form-select" required>
            <option [ngValue]="null" [disabled]="true" hidden>{{'ADD_SOLUTION.PLACE_HOLDER.CHOOSE_STATUS' | transloco}}</option>
            <option *ngFor="let option of statusOptions" [ngValue]="option.value">{{ option.value | titlecase }}</option>
          </select>
          <app-error [control]="createSolutionForm.get('status')"></app-error>
        </div>
      </div>

      <div class="flex flex-row gap-8">
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.INTEGRATIONS' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.PLACE_HOLDER.INTEGRATION_NAME' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <input formControlName="integrations" placeholder="{{'ADD_SOLUTION.PLACE_HOLDER.INTEGRATION_NAME' | transloco}}" class="fw-500" required>
          <app-error [control]="createSolutionForm.get('integrations')"></app-error>
        </div>
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.LABEL' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.PLACE_HOLDER.DISPLAY_NAME' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <input formControlName="label" placeholder="{{'ADD_SOLUTION.PLACE_HOLDER.DISPLAY_NAME' | transloco}}" class="fw-500" required>
          <app-error [control]="createSolutionForm.get('label')"></app-error>
        </div>
      </div>

      <div class="flex flex-row gap-8">
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.KEYWORD' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.PLACE_HOLDER.ENTER_TAGS' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <input formControlName="keywords" placeholder="{{'ADD_SOLUTION.PLACE_HOLDER.ENTER_TAGS' | transloco}}" class="fw-500" required>
          <app-error [control]="createSolutionForm.get('keywords')"></app-error>
        </div>
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.ICON_REFERENCE' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.ICON_REFERENCE' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <input formControlName="iconHref" placeholder="{{'ADD_SOLUTION.ICON_REFERENCE' | transloco}}" class="fw-500" required>
          <app-error [control]="createSolutionForm.get('iconHref')"></app-error>
        </div>
      </div>
    </form>

    <div>
      <div class="flex flex-row justify-between items-center">
        <div class="mat-subtitle-2 mb-0 fs-14 fw-700 pt-16 pb-16 pr-10">
          {{'ADD_SOLUTION.MEDIA' | transloco | uppercase }}
        </div>
        <mat-divider class="divider"></mat-divider>
        <div (click)="addMediaOccurrence()" class="flex flex-row justify-center items-center fw-500 cursor-pointer pl-10">
          <mat-icon class="mr-4 icon-sm" svgIcon="add"></mat-icon>
          <span class="link-text">{{'ADD_SOLUTION.ADD' | transloco }}</span>
        </div>
      </div>
     
      <ng-container *ngFor="let occurrence of occurrences; let i = index">
        <form [formGroup]="mediaForm[occurrence]" class="mb-20 p-12 media-form">
          <div class="flex flex-row justify-end items-center fw-500 pb-8">
            <mat-icon (click)="deleteMediaOccurrence(i)" class="mr-4 icon-sm cursor-pointer" svgIcon="remove"></mat-icon>
            <span (click)="deleteMediaOccurrence(i)" class="link-text cursor-pointer">{{'ADD_SOLUTION.REMOVE' | transloco }}</span>
          </div>
          <div class="flex flex-row gap-x-6">
            <div class="flex flex-col form-fields mb-16">
              <div class="flex flex-row justify-start items-center">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.NAME' | transloco | uppercase }}</label>
                <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.NAME' | transloco"
                   matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
              </div>
              <input formControlName="name" placeholder="{{'ADD_SOLUTION.NAME' | transloco}}" class="fw-500" required>
              <app-error [control]="mediaForm[occurrence]?.get('name')"></app-error>
            </div>
            <div class="flex flex-col form-fields mb-16">
              <div class="flex flex-row justify-start items-center">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.DESCRIPTION' | transloco | uppercase }}</label>
                <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.DESCRIPTION' | transloco"
                  matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
              </div>
              <input formControlName="description" placeholder="{{'ADD_SOLUTION.DESCRIPTION' | transloco}}" class="fw-500" required>
              <app-error [control]="mediaForm[occurrence]?.get('description')"></app-error>
            </div>
            <div class="flex flex-col form-fields mb-16">
              <div class="flex flex-row justify-start items-center">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.CATEGORY' | transloco | uppercase }}</label>
                <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.PLACE_HOLDER.CHOOSE_CATEGORY' | transloco"
                  matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
              </div>
              <select [formControl]="mediaForm[occurrence]?.get('category')" class="fw-500 form-select" required>
                <option [ngValue]="null" [disabled]="true" hidden>{{'ADD_SOLUTION.PLACE_HOLDER.CHOOSE_CATEGORY' | transloco}}</option>
                <option *ngFor="let option of mediaCategoryOptions" [ngValue]="option.value">{{ option.value | titlecase }}</option>
              </select>
              <app-error [control]="mediaForm[occurrence]?.get('category')"></app-error>
            </div>
          </div>

          <div class="flex flex-row gap-x-6">
            <div class="flex flex-col form-fields mb-16">
              <div class="flex flex-row justify-start items-center">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.MEDIA_HREF' | transloco | uppercase }}</label>
                <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.PLACE_HOLDER.MEDIA_FILE' | transloco"
                  matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
              </div>
              <input formControlName="mediaHref" placeholder="{{'ADD_SOLUTION.PLACE_HOLDER.MEDIA_FILE' | transloco}}" class="fw-500" required>
              <app-error [control]="mediaForm[occurrence]?.get('mediaHref')"></app-error>
            </div>
            <div class="flex flex-col form-fields mb-16">
              <div class="flex flex-row justify-start items-center">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.ICON_HREF' | transloco | uppercase }}</label>
                <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.ICON_HREF' | transloco"
                  matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
              </div>
              <input formControlName="iconHref" placeholder="{{'ADD_SOLUTION.ICON_HREF' | transloco}}" class="fw-500" required>
              <app-error [control]="mediaForm[occurrence]?.get('iconHref')"></app-error>
            </div>
            <div class="flex flex-col form-fields mb-16">
              <div class="flex flex-row justify-start items-center">
                <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_SOLUTION.SEQUENCE_NUMBER' | transloco | uppercase }}</label>
                <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_SOLUTION.PLACE_HOLDER.ENTER_SEQUENCE_NUMBER' | transloco"
                  matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
              </div>
              <input formControlName="sequenceNumber" placeholder="{{'ADD_SOLUTION.PLACE_HOLDER.ENTER_SEQUENCE_NUMBER' | transloco}}" class="fw-500" required>
              <app-error [control]="mediaForm[occurrence]?.get('sequenceNumber')"></app-error>
            </div>
          </div>
        </form>
      </ng-container>
    </div>
  </div>

  <div class="footer pt-16" >
    <div class="flex flex-row justify-end gap-x-6">
      <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}</button>
      <button class="accent" type="button" (click)="edit ? editSolution() : createDeployment()">{{'ADD_SOLUTION.SUBMIT' | transloco}}</button>
    </div>
  </div>
</div>

<div class="overlay" *ngIf="isLoading">
  <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
</div>

